export const USER_ACTION_STATE = {
  ACCOUNT_LOCKED: 'invalid_account_locked',
  BANNED: 'client_banned',
  CLIENT_UUID_FAILED: 'client_uuid_failed',
  CONSECUTIVE_LOGIN_FAILED: 'consecutive_login_failed',
  COULD_NOT_LOGIN: 'could_not_login',
  EMPTY_SESSION: 'empty_session',
  EXPIRED_ACCOUNT: 'client_account_expired',
  INVALID_ANSWER: 'invalid_answer',
  INVALID_CAPTCHA: 'invalid_captcha',
  INVALID_CREDENTIALS: 'invalid_client_credentials',
  INVALID_REQUEST: 'invalid_request',
  INVALID_USERNAME: 'invalid_username',
  LOGGED_IN: 'logged_in',
  LOGIN: 'client_login',
  NOT_LOADED: 'not_loaded',
  NO_SECURITY_QUESTIONS: 'no_security_questions',
  PASSWORD_RECOVERY: 'client_password_recovery',
  PASSWORD_RECOVERY_SENT: 'pass_rec_email_sent',
  SECURITY_QUESTIONS: 'client_unknown',
  STUDIO_REGISTERED: 'studio_registered',
  STUDIO_REGISTER_ERROR: 'studio_register_error',
  TEMPORARY_BANNED: 'client_temp_banned',
  TWOFA_REQUIRED: 'twofa_required',
  UNEXPECTED_ERROR: 'unexpected_error',
  UNVERIFIED_USER: 'invalid_user_unverified',
  WEAK_PASSWORD: 'WEAK_PASSWORD',
};

export const USER_IDENTITY_STATUS = {
  APPROVED: 'APPROVED',
  CONFIRMED: 'CONFIRMED',
  DECLINED: 'DECLINED',
  PENDING_ID_VERIFICATION: 'PENDING_ID_VERIFICATION',
  REJECTED: 'REJECTED',
  UNCONFIRMED: 'UNCONFIRMED',
};

export function getState(code) {
  const state = Object.keys(USER_ACTION_STATE).find((key) => USER_ACTION_STATE[key] === code);

  if (!state) {
    return USER_ACTION_STATE.UNEXPECTED_ERROR;
  }

  return USER_ACTION_STATE[state];
}
